import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FeedbackSection.module.css';

const FeedbackSection = ({ selectedReason, onFeedbackChange, onProceedToCancel, feedbackOptions }) => {
    const { t } = useTranslation();

    return (
        <div className={`${styles.feedbackSection} feedBackScroll`}>
            <h2 className={styles.feedbackHeading}>{t('feedback.heading')}</h2>
            <p className={styles.feedbackSubheading}>
                {t('feedback.subheading')}
            </p>
            <div className={styles.radioGroup}>
                {feedbackOptions.map((option) => (
                    <div key={option.value} className={styles.radioOption}>
                        <label>
                            <input
                                type="radio"
                                name="feedback"
                                value={option.value}
                                checked={selectedReason === option.value}
                                onChange={() => onFeedbackChange(option.value)}
                            />
                            {option.label}
                        </label>
                    </div>
                ))}
            </div>
            <button
                className={styles.proceedButton}
                onClick={onProceedToCancel}
            >
                {t('feedback.proceedButton')}
            </button>
        </div>
    );
};

export default FeedbackSection; 